var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.953 5.488 9.278.922C8.974.574 8.486.54 8.167.809c-.32.268-.373.81-.111 1.137l2.617 3.248H.788A.797.797 0 0 0 0 6c0 .445.353.806.788.806h9.885l-2.618 3.248c-.262.327-.202.862.111 1.137.324.285.85.214 1.111-.113l3.676-4.566c.239-.344.219-.691 0-1.024"
  })));
};
export default SvgArrowRight;